module.exports = __webpack_public_path__ + "static/media/IGDTUW3.8eb8aff4.jpg";